import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { DataChangeWatcherService } from 'mbs-ui-kit';

export const dataChangeWatcherGuard: CanDeactivateFn<unknown> = () => inject(DataChangeWatcherService).detectChanges();
